export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
    {children}
  </section>
);

export const Eyebrow = ({ children }) => (
  <div className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-brightblue mb-3">{children}</div>
);

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <div className="hero-gradient text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
      {eyebrow && <div className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-blue-300 mb-3">{eyebrow}</div>}
      <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight">{title}</h1>
      {subtitle && <p className="mt-4 text-lg text-blue-100 max-w-2xl leading-relaxed">{subtitle}</p>}
    </div>
  </div>
);
